import Vue from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue';
import { InertiaProgress } from '@inertiajs/progress';

import { setupSession } from '@/utils/session';
import '@/plugins';
import { i18n } from '@/plugins/i18n';

// This code will not be included in the build.
// It will allow you to be sure that the site is opened using the https protocol
// for the correct operation of all functions, and in particular the service worker.
if (process.env.NODE_ENV !== 'production') {
  if (window.location.protocol === 'http:') {
    window.location.protocol = 'https:';
  }
}

i18n.availableLocales.forEach((locale) => {
  i18n.setLocaleMessage(locale, {
    ...require(`@/lang/${locale}/base`),
    ...require(`@/lang/${locale}/modals`),
    aboutPage: require(`@/lang/${locale}/about-page`),
    dashboard: require(`@/lang/${locale}/dashboard`),
    documentCreate: require(`@/lang/${locale}/document-create`),
    editor: require(`@/lang/${locale}/editor`),
    helpPage: require(`@/lang/${locale}/help-page`),
    tour: require(`@/lang/${locale}/tour`),
  });
});

InertiaProgress.init({ color: '#0000c9' });
// Ensure AA container is initialized.
window.pfAnalyticsData ??= {};

createInertiaApp({
  resolve: (name) => import(`./pages/${name}`),
  setup({ el, app, props, plugin }) {
    Vue.use(plugin);

    const { auth } = props.props.initialPage.props;

    // In fact, the `auth` can be undefined so that's why this check is
    // present. The type is declared in a way the `auth` always exists
    // because here is the only place where the check matters as we don't
    // have public pages except `/login`.
    if (auth) {
      setupSession();

      window.pfAnalyticsData.pfUser = {
        userID: auth.ntid,
        userType: 'INT',
        userPageLoad: 'true',
        userBusinessUnit: auth.bu_name,
      };
    }

    return new Vue({
      i18n,
      render: (h) => h(app, props),
    }).$mount(el);
  },
  id: 'app',
});
